<template>
  <div>
    <label
      v-if="labelOutside && $attrs.label"
      for="todo"
    >{{ $attrs.label }}</label>

    <v-text-field
      v-bind="attrs"
      v-on="$listeners"
    >
      <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-text-field>
  </div>
</template>

<script>
/**
 * ### Differences from `v-text-field`
 * - A new `label-outside` prop is added that will replace the built-in label with one before the text field
 *
 * @example <r-text-field label="Standard Label"></r-text-field>
 * @example <r-text-field label="Label Outside" label-outside></r-text-field>
 *
 * @vuetify v-text-field
 */
export default {
  name: 'RTextField',
  inheritAttrs: false,
  props: {
    labelOutside: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Attributes
     *
     * @type object
     */
    attrs() {
      const attrs = Object.assign({}, {
        outlined: true,
      }, this.$attrs);

      if (this.labelOutside) {
        attrs.label = '';
      }

      return attrs;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
